import { addToSlot } from '../services/slots/slots';

export function slot() {}

export function renderTo(slotId) {
  return (target, propertyKey, descriptor) => {
    addToSlot(slotId, descriptor.value);
  };
}



// WEBPACK FOOTER //
// ./src/decorators/slot-decorator.js